<template>
  <v-app>
    <v-card>
      <v-card-title>
        Attendance report
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :error="$v.search.dates.$error"
                    v-model="dates"
                    label="Dates"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dates"
                  range
              ></v-date-picker>
            </v-menu>
            <span class="text-danger" v-if="$v.search.dates.$error">Dates is required</span></v-col>
          <v-col cols="4">
            <v-select
                :error="$v.search.course_id.$error"
                v-model="search.course_id" :items="courses" label="Course" item-text="title" item-value="id"
                outlined dense></v-select>
            <span class="text-danger" v-if="$v.search.course_id.$error">Course is required</span>
          </v-col>
          <v-col cols="4">
            <v-btn
                type="submit"
                @click="getSummaryReport"
                class="btn btn-primary text-white"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="report && report.length>0">
            <attendance-summary :report="report"></attendance-summary>
          </v-col>
          <v-col class="text-center" v-else>
            <h6>No data found</h6>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import AttendanceService from "@/core/services/attendance/AttendanceService";
import AttendanceSummary from "@/view/component/Attendance/AttendanceSummary";

const attendanceService = new AttendanceService();
export default {
  name: "AttendanceReport",
  props: ["academic_class", "timetable", "courses"],
  components: {
    AttendanceSummary
  },
  validations: {
    search: {
      dates: {required},
      course_id: {required}
    }
  },
  data() {
    return {
      report: [],
      dates: [],
      menu: false,
      search: {
        dates: [],
        course_id: ''
      }
    }
  }, mounted() {
    if (this.setDefaultDates()) {
      this.getSummaryReport();
    }
  }, methods: {
    getSummaryReport() {
      this.search.dates = this.dates;
      this.$v.$touch();
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)

      } else {
        this.search.class_id = this.academic_class.id;
        // this.search.time_table_id = this.timetable.id;
        attendanceService.getSummaryReport(this.search).then(response => {
          this.report = response.data.report
        });
      }
    },
    setDefaultDates() {
      this.dates = [];
      let startDate = this.$moment(new Date).subtract(30, 'days').format('YYYY-MM-DD');
      let endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dates.push(startDate)
      this.dates.push(endDate)
      this.search.course_id = this.courses[0].id
      return true
    }
  }
}
</script>

<style scoped>

</style>